import superMeta from '../_DES_CAT/metaDesCatNode.mjs'

export default {
    ...superMeta,
    name: '测试说明',
    type: 'DES_TEST',
}
